import React from 'react';
import i18n from '../../../i18n';
import swal from 'sweetalert';
// import { Spinner } from "react-bootstrap";
import { updateOfficer } from '../../../models/officers';
import FileInputNew from '../../helpers/fileInputNew';

export class EditOfficer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: this.props.data,
      ranks: this.props.ranks,
      errors: {},
      signature: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidMount() {
    let { input } = this.state;
    input.country_code = '+968';
    this.setState({ input });
  }

  onFileChange = (event) => {
    if (event.target.name === 'signature') {
      this.setState({ signature: event.target.files[0] });
    }
  };

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.validate()) {
      try {
        let { id } = this.state.input;
        const { input } = this.state;
        const formData = new FormData();
        formData.append('id', input.id);
        formData.append('name', input.name);
        formData.append('name_ar', input.name_ar);
        formData.append('mobile', input.mobile);
        formData.append('email', input.email);
        formData.append('username', input.username);
        if (input.password && typeof input.password !== undefined) {
          formData.append('password', input.password);
        }
        formData.append('rank', input.rank);
        formData.append('signature_file', this.state.signature);
        const response = await updateOfficer(formData, id);
        if (response.success) {
          swal(i18n.t('success'), 'User update successfully completed!!', 'success', {
            buttons: false,
            timer: 2000,
          });
          this.props.triggerReload(true);
        } else {
          let error_message = response.message;
          let resObject = response.data;
          for (const key in resObject) {
            if (Object.hasOwnProperty.call(resObject, key)) {
              let element = resObject[key];
              error_message += '\n' + element;
            }
          }
          swal('Failed', error_message, 'error');
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  testMobile(phoneNumber) {
    let reg =
      '^(+|00)(9[976]d|8[987530]d|6[987]d|5[90]d|42d|3[875]d|2[98654321]d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)(s?d){9}$';
    var OK = reg.match(phoneNumber);
    if (!OK) {
      window.alert("phone number isn't  valid");
    } else {
      window.alert('phone number is  valid');
    }
  }

  validate() {
    let { input } = this.state;
    let errors = {};
    let isValid = true;
    if (!input['name']) {
      isValid = false;
      errors['name'] = 'Please enter your Name.';
    }
    if (!input['mobile']) {
      isValid = false;
      errors['mobile'] = 'Please enter your Phone Number.';
    }
    if (!input['username']) {
      isValid = false;
      errors['username'] = 'Please enter a valid Username.';
    }
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
    );

    if (!input['email'] || !pattern.test(input['email'])) {
      isValid = false;
      errors['email'] = 'Please enter valid email address.';
    }
    if (!input['rank']) {
      isValid = false;
      errors['rank'] = 'Please select a rank.';
    }

    this.setState({
      errors: errors,
    });
    console.log(errors);
    return isValid;
  }

  render() {
    let { lang } = this.props;
    let { ranks } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="single-page">
            <div className="col-md-12 d-block mx-auto">
              <div className="wrapper wrapper2">
                <form id="UpdateUser" className="card-body" tabIndex="500" autoComplete="off">
                  <div className="row">
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('name')}</label>
                        &nbsp;
                        <input
                          type="text"
                          name="name"
                          value={this.state.input.name}
                          onChange={this.handleChange}
                          autoComplete="name"
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.name}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('name')}({i18n.t('arabic')})
                        </label>
                        &nbsp;
                        <input
                          type="text"
                          name="name_ar"
                          value={this.state.input.name_ar}
                          onChange={this.handleChange}
                          autoComplete="name_ar"
                          className="form-control custom-input"
                          style={{ direction: 'rtl' }}
                        />
                        <div className="text-danger">{this.state.errors.name_ar}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('phone_number')}</label>
                        <div className="d-flex justify-content-between align-items-center">
                          <input
                            type="text"
                            className="form-control col-9"
                            name="country_code"
                            value={this.state.input.country_code}
                            disabled
                            style={{ width: '20%' }}
                          />
                          <input
                            type="text"
                            className="form-control col-11"
                            name="mobile"
                            value={this.state.input.mobile}
                            onChange={this.handleChange}
                            style={{ width: '80%' }}
                          />
                        </div>

                        <div className="text-danger">{this.state.errors.mobile}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('email')}</label>
                        <input
                          type="text"
                          name="email"
                          value={this.state.input.email}
                          onChange={this.handleChange}
                          style={{ direction: 'ltr' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.email}</div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <label>{i18n.t('username')}</label>
                      <input
                        type="text"
                        name="username"
                        value={this.state.input.username}
                        onChange={this.handleChange}
                        autoComplete="username"
                        className="form-control custom-input "
                      />
                      <div className="text-danger">{this.state.errors.username}</div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <label>{i18n.t('password')}</label>
                      <input
                        type="text"
                        name="password"
                        value={this.state.input.password}
                        onChange={this.handleChange}
                        autoComplete="password"
                        className="form-control custom-input "
                      />
                      <div className="text-danger">{this.state.errors.password}</div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('rank')}</label>
                        <select
                          className="form-control custom-input "
                          name="rank"
                          value={this.state.input.rank}
                          onChange={this.handleChange}
                        >
                          <option value="">-- {i18n.t('rank')} --</option>
                          {ranks.map((item, i) => {
                            return (
                              <option value={item.id} key={i}>
                                {lang === 'ar' ? item.rank_ar : item.rank_en}
                              </option>
                            );
                          })}
                        </select>
                        <div className="text-danger">{this.state.errors.role}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('signature')}</label>
                        <FileInputNew
                          wrapperClass=""
                          placeholder={i18n.t('choose_file')}
                          id="signature"
                          name="signature"
                          onChange={this.onFileChange}
                          className="form-control"
                          is_file_view={true}
                          format_url={this.state.input?.signature}
                        />
                      </div>
                    </div>

                    <button type="button" className="btn btn-primary btn-block mt-5" onClick={this.handleSubmit}>
                      {i18n.t('submit')}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
